import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { formatDate } from "@/lib/datetime";
import { Card, errMsg } from "@/components/email/EmParts";

export const AmbiguousReview = ({ batchId, editable, onChange }) => {
  const { can } = useAuth();
  const [d, setD] = useState(null);
  const load = () => api.get(`/email-marketing/mailcoach/batches/${batchId}/ambiguous`).then((r) => setD(r.data.items)).catch(() => setD([]));
  useEffect(() => { load(); }, [batchId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d || !d.length) return null;
  const pick = async (key, legacyId) => {
    try { await api.put(`/email-marketing/mailcoach/batches/${batchId}/resolutions`, { email: key, legacy_id: legacyId || null }); toast.success(legacyId ? "Customer selected. Run the dry run again" : "Selection cleared"); load(); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  const done = d.filter((x) => x.selected).length;
  return (
    <Card title={`Ambiguous matches: ${done} of ${d.length} resolved`} testId="mc-ambiguous-review">
      <p className="text-xs text-slate-500 mb-2">Choose which existing customer this Mailcoach subscriber belongs to. Accounts are never merged. Unresolved ones are left for review, and their unsubscribes are still applied.</p>
      <div className="space-y-2 max-h-[480px] overflow-y-auto">{d.map((x) => (
        <div key={x.key} className="border-t border-slate-100 pt-2 text-xs" data-testid={`mc-amb-${x.key}`}>
          <p className="font-semibold text-slate-700">{x.email} <span className="font-normal text-slate-500">· Mailcoach {x.mailcoach_status} · {(x.reason || "").replace(/_/g, " ")}</span></p>
          <div className="flex flex-wrap gap-2 mt-1">
            {x.candidates.map((c) => (
              <label key={c.legacy_id} className={`flex items-center gap-1.5 border rounded-lg px-2 py-1 ${x.selected === c.legacy_id ? "border-indigo-400 bg-indigo-50" : "border-slate-200"}`}>
                <input type="radio" name={`amb-${x.key}`} checked={x.selected === c.legacy_id} disabled={!editable || !can("email_marketing.settings")} onChange={() => pick(x.key, c.legacy_id)} data-testid={`mc-amb-pick-${c.legacy_id}`} />
                <span>{c.name || "(no name)"} · #{c.legacy_id}{c.postcode ? ` · ${c.postcode}` : ""} · {c.orders} jobs/orders{c.created_at ? ` · since ${formatDate(c.created_at)}` : ""}</span>
              </label>))}
            {x.selected && editable && !x.applied && <button type="button" className="text-slate-500 underline" onClick={() => pick(x.key, null)} data-testid={`mc-amb-clear-${x.key}`}>Leave for review</button>}
          </div>
        </div>))}</div>
    </Card>
  );
};
